/**
 * effects.js
 *
 * All visual effect definitions used by both generateCatch (useCatchAnimation)
 * and the fish sprite rendering (CatchScreen, InventoryView, FishDetailOverlay).
 *
 * Extracted from App.js lines 55–79.
 */

// Effect groups — define which effects a species can roll
export const EFFECTS = {
  BASIC:   ['default', 'shiny'],
  PREMIUM: ['default', 'ethereal', 'neon', 'prismatic', 'golden'],
  UNIQUE:  ['default'],
};

// CSS filter applied to the fish sprite image
export const effectFilters = {
  default:  'none',
  shiny:    'brightness(1.5) contrast(1.2)',
  neon:     'saturate(400%) brightness(1.3)',
  ethereal: 'opacity(0.7) sepia(50%) hue-rotate(110deg) brightness(1.2)',
  golden:   'sepia(100%) saturate(500%) hue-rotate(-30deg) brightness(1.2) contrast(1.1)',
  prismatic: 'none', // Handled by the CSS class animation instead
};

// Drop-shadow glow color keyed by rarity
export const rarityGlows = {
  common:    '#ffffff', // White
  uncommon:  '#44ff44', // Green
  rare:      '#4444ff', // Blue
  special:   '#ff00ff', // Magenta
  legendary: '#ffcc00', // Golden
  mythical:  '#ffff00', // Yellow
};